import React from 'react';
import { PackageIntlProvider } from '../../../intl-provider';
import { DEFAULT_LOCALE } from '../../../intl-provider/ProFormaIntlProvider';
import { NoticeDialog } from './NoticeDialog';
import { Notices } from './noticeTypes';
export var Notice = function Notice(_ref) {
  var noticeType = _ref.noticeType,
    handleClose = _ref.handleClose,
    _ref$settings = _ref.settings,
    _ref$settings$customL = _ref$settings.customLocale,
    customLocale = _ref$settings$customL === void 0 ? DEFAULT_LOCALE : _ref$settings$customL,
    intlValues = _ref$settings.intlValues,
    errorDetails = _ref$settings.errorDetails,
    overrideZIndex = _ref$settings.overrideZIndex;
  var notice = Notices[noticeType];
  if (!notice) {
    // eslint-disable-next-line no-console
    console.error("Could not show notice, notice type ".concat(noticeType, " does not exist"));
    handleClose();
  }
  return /*#__PURE__*/React.createElement(PackageIntlProvider, {
    locale: customLocale
  }, /*#__PURE__*/React.createElement(NoticeDialog, {
    title: notice.title,
    titleVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.titleVars,
    message: notice.message,
    messageVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.msgVars,
    confirmText: notice.confirmText,
    confirmLink: notice.confirmLink,
    handleClose: handleClose,
    isErrorNotice: notice.isErrorNotice,
    errorDetails: errorDetails,
    isWarningNotice: notice.isWarningNotice,
    overrideZIndex: overrideZIndex
  }));
};